import styled from "styled-components"

export const Container = styled.div`
    flex: auto;
    overflow: auto;

    &::-webkit-scrollbar-track {
        background-color: #FFF;
    }

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #C3C3C3;
        border-radius: 4px;
    }

    scrollbar-width: thin;
    scrollbar-color: #C3C3C3;
    scrollbar-track-color: #FFF;

    button {
        margin-bottom: 4rem;
    }
`

export const ContainerLoading = styled.div`
    flex: auto;
    display: flex;
`

export const Table = styled.table`
    border-collapse: collapse;
    margin: 25px 0;
    font-size: 0.9rem;
    width: 100%;
    margin-bottom: 2.5rem;

    thead{
        tr{
            background: var(--colorBackgroundCardsDashboard);
            @media (max-width: 545px) {
                th:nth-child(2) {
                    display: none;
                }

            }

            th:first-child{
                text-align: left;
            }
        }
    }


    tbody{
        tr{
            border-bottom: 1px solid #DDD;
            
            td{
                width: 25%;
                text-align: center;
            }

            &:nth-child(even){
                background: #f2f2f2;
            }

            td:first-child{
                text-align: left;
            }
            
            @media (max-width: 545px) {
                td {
                    width: 33.3%;

                    &:nth-child(2) {
                        display: none;
                    }
                }
            }
        }
    }


    th, td {
        padding: 0.7rem 0.9rem;
      
    } 
`

export const TotalValue = styled.div`
    width: 100%;
    position: absolute;
    bottom: 0.4rem;
    right: 0;

    border-top: 1px solid var(--colorFontsCardsDashboard);
    background: #FFF;
    font-size: 0.9rem;
    padding: 1rem 0.5rem;

    display: flex;
    align-items: center;
    justify-content: space-between;

    svg{
        font-size: 1rem;
        color: var(--colorFontsCardsDashboard);
    }

    div{
        text-align: center;
        display: flex;
        align-items: center;
        flex-direction: column;

        span{
            font-weight: 900;
        }

        p{
            font-size: 0.8rem;
        }
    }

    .red{
        color: #e05f59;
    }

    .blue{
        color: #00008b;
    }

    .green{
        color: #2e9699;
    }
`